import { TFunction } from 'i18next'

import { InvoiceComplianceMode } from '@features/invoices/enums/invoiceComplianceMode'
import { Organization } from '@modules-deprecated/app/organization/types/organization'

import { GetMissingCompanyDetailsFormSchema } from '../types/getMissingCompanyDetailsFormSchema'
import { MissingCompanyDetailsFormSchema } from '../types/missingCompanyDetailsFormSchema'
import { getCompanyFormValidationSchema } from './getCompanyFormValidationSchema'
import { getFrenchCompanyFormValidationSchema } from './getFrenchCompanyFormValidationSchema'

interface GetCompanyFormValidationSchemaByComplianceModeOptions {
  complianceMode: InvoiceComplianceMode
  countryId: Organization['countryId'] | undefined
  t: TFunction
}

const validationSchemaByComplianceMode: Record<InvoiceComplianceMode, GetMissingCompanyDetailsFormSchema> = {
  [InvoiceComplianceMode.Default]: getCompanyFormValidationSchema,
  [InvoiceComplianceMode.French]: getFrenchCompanyFormValidationSchema,
}

export const getCompanyFormValidationSchemaByComplianceMode = ({
  complianceMode,
  ...options
}: GetCompanyFormValidationSchemaByComplianceModeOptions): MissingCompanyDetailsFormSchema =>
  validationSchemaByComplianceMode[complianceMode](options)
